import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';

import { MethodProps } from '../types';
import { useI18n } from '~Hooks';
import { useStorage } from '~Components/Storage';
import NumberInput from '~ComponentsImproved/Numpad';
import WaiterAidGiftcardPayment from '~Components/WaiterAidGiftcard';

const WaiterAidGiftcard: React.FunctionComponent<MethodProps> = ({
  payment,
  amount,
  onMetaChange,
  onComplete,
  onFail,
}) => {
  const [storage] = useStorage();
  const { i18n } = useI18n();
  const [showTipModal, setShowTipModal] = useState(!payment.disableTip || storage.enableTipping);

  if (payment.status === 'COMPLETED') {
    return null;
  }

  if (showTipModal) {
    return (
      <NumberInput
        key="tip"
        initialValue={'0'}
        decimal
        title={i18n('TM.Tip')}
        onSubmit={(tipAmount) => {
          setShowTipModal(false);

          const tip = parseFloat(tipAmount);
          if (isNaN(tip)) {
            onFail();
            return;
          }

          onMetaChange({ tip: tip * 100 });
          setTimeout(() => setShowTipModal(false), 1000);
        }}
        onClose={() => {
          setShowTipModal(false);
          onFail(i18n('Payment.Canceled'));
        }}
      />
    );
  }

  const tip = payment.meta.tip;
  return (
    <WaiterAidGiftcardPayment
      id={`waid_${uuid()}`}
      amount={amount! + (tip ?? 0)}
      onFail={() => onFail()}
      onComplete={(transactionId) =>
        onComplete(null, {
          transactionId,
        })
      }
    />
  );
};

export default WaiterAidGiftcard;
